import { render, staticRenderFns } from "./DocumentDeleteProvider.vue?vue&type=template&id=e07fd0ee&scoped=true&"
import script from "./DocumentDeleteProvider.vue?vue&type=script&lang=ts&"
export * from "./DocumentDeleteProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07fd0ee",
  null
  
)

export default component.exports